import { render, staticRenderFns } from "./medic-input.vue?vue&type=template&id=902db6a6&scoped=true&"
import script from "./medic-input.vue?vue&type=script&lang=js&"
export * from "./medic-input.vue?vue&type=script&lang=js&"
import style0 from "./medic-input.vue?vue&type=style&index=0&id=902db6a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902db6a6",
  null
  
)

export default component.exports